var NO_AVAILABLE_LIST = null;
var NO_AVAILABLE_RECORD = null;
var observerNAhistory = null;
var observerNAList = null;

export function getNoAvailableRecord() {
  return NO_AVAILABLE_RECORD;
}
export function setNoAvailableRecord(record) {
  if (!record) {
    NO_AVAILABLE_RECORD = null;
  } else {
    NO_AVAILABLE_RECORD = [];
    for (const i in record) {
      NO_AVAILABLE_RECORD.push(record[i]);
    }
    if (observerNAhistory) {
      observerNAhistory();
    }
  }
}
export function observerRecordNAhistory(supervisorObserver) {
  observerNAhistory = supervisorObserver;
}

export function getNoAvailableList() {
  return NO_AVAILABLE_LIST;
}
export function setNoAvailableList(noAvailableList) {
  NO_AVAILABLE_LIST = noAvailableList;
  if (observerNAList) {
    observerNAList();
  }
}
export function observerNoAvailableList(listObserver) {
  observerNAList = listObserver;
}



// WEBPACK FOOTER //
// ./src/js/Singletons/NoAvailableRecordSingleton.js